import { render, staticRenderFns } from "./Kliniki.vue?vue&type=template&id=5b7fbc40&scoped=true&"
import script from "./Kliniki.vue?vue&type=script&lang=js&"
export * from "./Kliniki.vue?vue&type=script&lang=js&"
import style0 from "./Kliniki.vue?vue&type=style&index=0&id=5b7fbc40&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b7fbc40",
  null
  
)

export default component.exports